import { ResourceGroup } from './resource-group';

export class ResourceCollection {
    genericCollection: ResourceGroup[];
    vehicleCollection: ResourceGroup[];
    roomCollection: ResourceGroup[];
}
